import { queryOptions } from '@tanstack/react-query';

import type { GetPublicProfileArgs } from './auth.types';

import { getProfileRequest, getPublicProfileRequest } from './auth.requests';

export const getProfileOptions = () =>
  queryOptions({
    queryFn: () => getProfileRequest(),
    queryKey: ['profile'],
  });

export const getPublicProfileOptions = (args: GetPublicProfileArgs) =>
  queryOptions({
    queryFn: () => getPublicProfileRequest(args),
    queryKey: ['profile', args],
  });
